// Keep same algorithm as PHP (first byte is XOR key; rest are XORed bytes)
const decryptEmail = (encodedString) => {
    let email = '';
    const keyInHex = encodedString.slice(0, 2);     // was substr(0, 2)
    const key = parseInt(keyInHex, 16);

    for (let n = 2; n < encodedString.length; n += 2) {
        const char = parseInt(encodedString.slice(n, n + 2), 16); // was substr(n, 2)
        email += String.fromCharCode(char ^ key);
    }
    return email;
};

function upgradeSpan(span) {
    if (!span || span.dataset.state !== 'hidden') return;
    const enc = span.getAttribute('data-email-enc');
    if (!enc) return;

    const button = span.querySelector('.email-reveal');
    const reveal = () => {
        const email = decryptEmail(enc);
        // Replace contents with a link
        const a = document.createElement('a');
        a.href = `mailto:${email}`;
        a.textContent = email;
        a.className = 'email-link';
        span.replaceChildren(a);
        span.dataset.state = 'visible';
    };

    // Reveal on click (user gesture)
    if (button) button.addEventListener('click', reveal, { once: true });

    // Optional: also reveal on keyboard focus + Enter
    span.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && span.dataset.state === 'hidden') {
            e.preventDefault();
            reveal();
        }
    });
}

export default function initEmailProtect(root = document) {
    const nodes = root.querySelectorAll('.email-protected[data-email-enc][data-state="hidden"]');
    nodes.forEach(upgradeSpan);
}
